import React from 'react';
import { CompositeView, GridView, SimpleView } from '@digital/ui';
import TabelaFornecedores from './TabelaFornecedores';

const PainelFinanceiro = () => {
  return (
    <SimpleView>
      <CompositeView>
        <GridView noform>
          <TabelaFornecedores />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default PainelFinanceiro;
